// System health service — live status of every external dependency of the platform
import { fetchWithAuth } from '@startus/lib';
import type { SystemStatus } from '../types/system-health';

const API_BASE_URL = import.meta.env.VITE_API_URL;

if (!API_BASE_URL) {
  throw new Error('VITE_API_URL is not defined');
}

/** Fetches service status from GET /api/v1/admin/system-status (takes up to ~16 s) */
export const fetchSystemStatus = async (): Promise<SystemStatus> => {
  const response = await fetchWithAuth(`${API_BASE_URL}/api/v1/admin/system-status`, {
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch system status: ${response.status}`);
  }

  // API wraps response in { success, data, meta } via TransformInterceptor
  const body = (await response.json()) as { data: SystemStatus };
  return body.data;
};
